import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=97fb033e&scoped=true&"
import script from "./WelcomeCard.vue?vue&type=script&lang=js&"
export * from "./WelcomeCard.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCard.vue?vue&type=style&index=0&id=97fb033e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fb033e",
  null
  
)

export default component.exports